import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MisReportsService {
  constructor(private http: HttpClient) {}
  // downloadFile(): any {
  // 	return this.http.get('http://localhost/accesshr/api/test', {responseType: 'blob'});
  // }

  getHoldReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_mrf_hold_report`
    );
  }
  // biometricReportTesting(): Observable<any[]> {
  //   return this.http.get<any[]>(
  //     `${environment.apiUrl}/mis-reports/get_biometric_report_testing`
  //   );
  // }
  biometricReport(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_biometric_report`,{ params: param }
    );
  }

  empMonthlyAttReport(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/emp_monthly_attendce_report`,{ params: param }
    );
  }

  catWiseTimeSpentSumm(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/category_wise_timesheet_report`,{ params: param }
    );
  }

  downloadRejoineeReport(req): Observable<any[]> {
    // const req  = { };
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_rejoiniee_reports`,
      req
    );
  }
  downloadCompOffReport(req): Observable<any[]> {
    // const req  = { };
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_comp_off_reports`,
      req
    );
  }
  getPayrollReportsData(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/payroll-dashboard`,
      req
    );
  }
  getAttendanceDataRegionWise(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/attendnace-dashboard-region-wise`,
      req
    );
  }
  getExitDataRegionWise(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/exit-dashboard`,
      req
    );
  }
  getAttendanceDataSegmentWise(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/attendnace-dashboard-segment-wise`,
      req
    );
  }
  downloadPendingBank(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/mis-reports/getPendingAccoutReport`
    );
  }
  editMappedReports(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/edit_mapped_reports`,
      req
    );
  }
  getMappedReports(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_mapped_report`
    );
  }
  downloadEmpReport(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_emp_reprt`,
      req
    );
  }

  downloadExitEmployeeDump(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_exit_emp_dump`,
      req
    );
  }

  getAttendanceTXT(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_attendance_txt`,
      req
    );
  }

  

  getLoprTXT(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_lopr_txt`,
      req
    );
  }

  getMrfTatReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/mrf_tat_report`
    );
  }
  getPcCodeReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_pc_code_data`
    );
  }
  getActiveMasterData(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_active_master_data`
    );
  }
  getkudosDumpReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_kudos_dump_reports`
    );
  }
  getBanksDetailReport(): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_bnk_detail_reports`,
      {}
    );
  }
  downloadAllowanceDeductionReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_allowance_deduction_report`,
      req
    );
  }
  downloadAbscondeeReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_abscondee_report`,
      req
    );
  }
  downloadNewJoiningsReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_new_joinigs`,
      req
    );
  }

  downloadRegReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_att_reg`,
      req
    );
  }


  downloadSummaryOT(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_summary_ot`,
      req
    );
  }
  // active and in_active emp records by status
  getEmpActiveReport(status): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/employee_active_report/` + status
    );
  }
  downloadSalaryHold(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_salary_hold_report`,
      req
    );
  }

  getEmployeeMasterReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/employee_master_report`
    );
  }
  getAttendanceExcel(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_attendance_excel`,
      req
    );
  }
  downloadPendingJoiningReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/download_pending_joiniee_reports`
    );
  }
  downloadTransferEmployee(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_transfer_report`,
      req
    );
  }
  downloadTransferMonthWise(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_transfer_month_report`,
      req
    );
  }
  downloadRenewalLetterDump(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/renewal_letter_report`,
      req
    );
  }
  downloadExitEmployee(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_exit_employee`,
      req
    );
  }
  downloadAttendaceCorrectionXlsx(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_attendance_correction_xlsx`,
      req
    );
  }
  downloadOTCorrectionXlsx(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_ot_correction_xlsx`,
      req
    );
  }
  downloadAttendanceDayWiseExcel(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_att_day_wise_xlsx`,
      req
    );
  }
  downloadAttendanceSummaryExcel(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_att_summary_xlsx`,
      req
    );
  }
  downloadMediclaimReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_mediclaim_report`,
      req
    );
  }

  downloadEmployeeExitReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/download_exit_report`
    );
  }
  getNewJoinersForESIC(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/new_joiners_report_esic`
    );
  }
  getExitFNFReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/download_exit_fnf_report`,
      req
    );
  }
  getmrfNewJoinersReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/mrf_new_joiners_report`,
      req
    );
  }

  // Report Settings

  mappedReports(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_mapped_reports`
    );
  }
  addReportRole(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/add_report_role`,
      req
    );
  }

  addReportEmpRole(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/add_rprts_emp_map`,
      req
    );
  }

  deleteReportEmpMap(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/delete_report_emp_map`,
      req
    );
  }
  removeReportRole(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/remove_mapped_report_role`,
      req
    );
  }
  updateReport(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/update_report`,
      req
    );
  }

  downloadBankMaster(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/mis-reports/downloadBankMaster`,
      { params: param }
    );
  }

  downloadLeaveBalMaster(data): Observable<any> {
    // let param = new HttpParams();
    // for (const key in data) {
    //   if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
    //     param = param.append(key, data[key]);
    //   }
    // }
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/downloadLeaveBalMaster`,
      data
    );
  }

  downloadLeaveMaster(data): Observable<any> {
    // let param = new HttpParams();
    // for (const key in data) {
    //   if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
    //     param = param.append(key, data[key]);
    //   }
    // }
    return this.http.post<any>(
      `${environment.apiUrl}/leaves/leaveMasterExcel`,
      data
    );
  }

  downloadQueryMaster(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/report/downloadQueryMaster`,
      { params: param }
    );
  }

  downloadWpdQueryMaster(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/ivr/DownloadWPDIVRMaster`,
      { params: param }
    );
  }

  // report & category

  categoryList(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/category_dropdown`
    );
  }

  reportsGet(data): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_report?page=${data.page}&limit=${data.limit}`
    );
  }

  addReport(req): Observable<any> {
    if (!req.rprt_id) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/mis-reports/add_report_action`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/mis-reports/edit_report_action`,
        req
      );
    }
  }

  reportsEdit(rprtID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/edit_report/${rprtID}`
    );
  }

  editReportStatus(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/edit_status_report`,
      data
    );
  }

  deleteReport(rptID): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/delete_report`,
      { rprt_id: rptID }
    );
  }

  // report category

  reportCategGet(data): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_rpt_cat?page=${data.page}&limit=${data.limit}`
    );
  }

  addCategory(req): Observable<any> {
    if (!req.cat_id) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/mis-reports/add_rpt_cat_action`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/mis-reports/edit_rpt_cat_action`,
        req
      );
    }
  }

  categEdit(catID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/edit_rpt_cat/${catID}`
    );
  }

  editCategStatus(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/edit_rpt_cat_status`,
      data
    );
  }

  deleteCateg(catId): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/delete_rpt_cat`,
      { cat_id: catId }
    );
  }

  // downloadAllCanidatesReport(): Observable<any> {
  //   return this.http.get<any[]>(`${environment.apiUrl}/mis-reports/get_candidates_report`);
  // }
  downloadInternalCanidatesReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_internal_cand_report`
    );
  }
  downloadExternalCanidatesReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_external_jobs_cand_report`
    );
  }
  downloadReferalCanidatesReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_referal_cand_report`
    );
  }
  mrfTatReport(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_mrf_tat_report`,
      { params: param }
    );
  }

  mrfCandidateReport(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }

    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_candidate_database_report`,{params:param}
    );
  }
  sgnTatReport(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_mrf_sgna_report`,
      { params: param }
    );
  }
  
  downloadOfferAppointCandidate(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_candidate_report`,
      { params: param }
    );
  }
  getAllQryStatus(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/helpdesk/get_qry_stage`);
  }

  downloadLeaveLastMonth(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/last_month_leave_master`,
      { params: param }
    );
  }
  myLeaveReport(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/my_leave_report`,
      { params: param }
    );
  }

  checkYearLeaveFiles(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/leaves/yearLeavefile`, {
      params: param,
    });
  }

  downloadMasterChangesReport(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms !== '' &&
        data.forms !== undefined &&
        data.forms !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/master_changes_report_` +
        data.forms['type'],
      { params: param }
    );
  }

  getUserLoginConsent(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/user_login_consent_report`,
      { params: param }
    );
  }

  downloadPayoutReport(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/talent_spotter_payout_report`,
      req
    );
  }
  forceGenerateBank(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/scheduler/emp_bank_master`
    );
  }

  upldAttenThroughExcel(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/upload_atten_by_excel`,
      data
    );
  }


  uploadUserLoprThroughExcel(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/upload_user_lopr_txt`,
      data
    );
  }


  uploadUserLopThroughExcel(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/upload_user_lop_txt`,
      data
    );
  }
  
  getLopTXT(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_lop_txt`,
      req
    );
  }

  refreshWpdQueryMaster(): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/ivr/cronDownloadWPDIVRMaster`,
      { refresh: 'refresh' }
    );
  }

  getSiteWiseAttenSummThroughExcel(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/mis-reports/get_site_wise_att_summ`,
      data
    );
  }

  downloadEmpAssesmentReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/download_emp_assesment_report`
    );
  }

  downloadKabisBiometricAttendanceReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/get_kabis_biometric_report`
    );
  }
  
  downloadRetentionReport(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/mis-reports/get_exit_retention_report`);
  }

  empModalAll(type): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/Employee_Master_History_Report/`+type
    );
  }

  // synergyReport(): Observable<any[]>{
  //   return this.http.get<any[]>(
  //     `${environment.apiUrl}/mis-reports/synergy_report`
  //   );
  // }
  synergyReport(): Observable<any[]>{
    return this.http.get<any[]>(
      `${environment.apiUrl}/mis-reports/synergy_report`
    );
  }
}
